export default "__VITE_ASSET__CC4BjxG8__"